<template>
    <div class="select-wrapper" @click.stop="">
        <label v-if="labelText" v-text="labelText"> </label>
        <v-select
            :placeholder="placeholder"
            :id="id"
            v-model="current"
            :options="options"
            :reduce="(option) => option[optionKey]"
            :label="optionLabel"
            :disabled="disabled"
            :multiple="multiple"
            :required="required"
            @search:focus="focused"
            @search:blur="blurred"
            :append-to-body="appendToBody"
            :calculate-position="withPopper"
            :clearable="clearable"
            @input="$emit('input', current)"
            :components="{OpenIndicator}"
        ></v-select>
        <input
            ref="dummy"
            type="text"
            :name="name"
            class="v-select-hidden"
            aria-label="Selected Option"
            v-model="current"
            :required="required"
            :disabled="disabled"
            autocomplete="off"
            readonly
        />
    </div>
</template>

<script>
import Vue from "vue";
import VueSelect from "vue-select";
import { createPopper } from "@popperjs/core";

Vue.component("v-select", VueSelect);

export default {
    props: {
        appendToBody: {
            type: Boolean,
            default: true,
        },

        autofill: {
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        id: {
            type: String,
            default: "",
        },

        name: {
            type: String,
            default: "input_dummy",
        },

        options: {
            type: Array,
            required: true,
        },

        optionKey: {
            type: String,
            default: "id",
        },

        optionLabel: {
            type: String,
            default: "label",
        },

        multiple: {
            type: Boolean,
            default: false,
        },

        required: {
            type: Boolean,
            default: false,
        },

        clearable: {
            type: Boolean,
            default: true,
        },

        value: {
            default: null,
            required: true,
        },

        labelText: {
            default: null,
            required: false,
        },

        placeholder: {
            type: String,
            default: "Please select",
        },
        popperClass: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            current: this.value,
            OpenIndicator: {
                render: createElement => {
                    return createElement('svg-icon', {
                        attrs: {
                            id: 'selectCaret'
                        }
                    })
                }
            },
        };
    },

    computed: {
        uid() {
            return this._uid;
        },
    },

    watch: {
        value(now, was) {
            this.current = now;
        },

        current(now, was) {
            this.checkValidOption();
            this.$emit("input", this.current);
        },

        options: {
            handler() {
                this.checkValidOption();
            },
            deep: true,
        },
    },

    created() {
        this.checkValidOption();
    },

    mounted() {},

    methods: {
        focused() {
            $(this.$refs.dummy).trigger("softFocus");
        },

        blurred() {
            $(this.$refs.dummy).trigger("softBlur");
        },

        checkValidOption() {
            var valid = false;

            if (this.multiple == true) {
                valid = true;
                return valid;
            }

            if (this.current !== null) {
                $.each(this.options, (idx, option) => {
                    // IF we have a value set correctly based on our key value
                    if (option[this.optionKey] == this.current) {
                        valid = true;

                        // If somehow we're set based on the label, change to the key
                    } else if (option[this.optionLabel] == this.current) {
                        this.current = option[this.optionKey];
                        valid = true;
                    }
                });

                if (!valid) {
                    this.current = null;
                }
            }

            return valid;
        },

        withPopper(dropdownList, component, { width }) {
            dropdownList.style.width = width;
            if(this.popperClass) {
                dropdownList.classList.add(this.popperClass);
            }

            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: "bottom",
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: "toggleClass",
                        enabled: true,
                        phase: "write",
                        fn({ state }) {
                            component.$el.classList.toggle(
                                "drop-up",
                                state.placement === "top"
                            );
                        },
                    },
                ],
            });

            return () => popper.destroy();
        },
    },
};
</script>
